import React, { Component } from 'react';

import repeat from '../../../../../assets/icons/repeat.svg';

export default class Repeat extends Component {
  render() {
    const { openRepeat, selectedRepeat, repeats, repeat, closeRepeat } = this.props;
    return (
      <div className="mobile-duties__features--item">
        <h2>تکرار</h2>
        <div className="mobile-float-input d-flex" onClick={() => openRepeat()}>
          <img src={repeat} className="mic" />
          <div className="mobile-float-input__value">
            {selectedRepeat ? selectedRepeat : 'هشدار را تنظیم کنید'}
          </div>
        </div>
        {repeat ?
          <div className="mobile-duty-alarms d-flex flex-column fadeAnimation">
            {
              repeats.map(item => (
                <div className="mobile-duty-alarms__alarm d-flex" key={item.name}>
                  <input type="radio" name="alarm" defaultChecked={item.checked} onChange={() => closeRepeat(item.name, item.id)} />
                  <div className="mr-2">{item.name}</div>
                </div>
              ))
            }
          </div> : null
        }
      </div>
    )
  }
}